import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardApiIsomorphicFetchEvent } from '#/modules/orgDashboard/api/listing/orgDashboardApiFetchEvent';
import { orgDashboardEditEventRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardEditEventPageLoadable } from './OrgDashboardEditEventPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId, eventId },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardEditEventRoute>) {
  const [event] = await Promise.all([
    orgDashboardApiIsomorphicFetchEvent({ request, context })(orgId, eventId),
    OrgDashboardEditEventPageLoadable.load(),
  ]);

  return { event };
}

export default function OrgDashboardEditEventHorizonRoute({
  loaderData: { event },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Edit Event')}>
      <OrgDashboardEditEventPageLoadable event={event} />
    </RouteModule>
  );
}
